module.exports = __webpack_public_path__ + "trademark1.png?f524f61a14d2dec1dce92f41b58a6616";


//////////////////
// WEBPACK FOOTER
// ./static/assets/trademark1.png
// module id = 501
// module chunks = 0